import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { CreditCard, Loader2 } from "lucide-react";

const PaymentMethodModal = ({
  isOpen,
  onClose,
  onExistingCardSelect,
  onNewCardSelect,
  isLoading = false
}) => {
  const [activeLoading, setActiveLoading] = useState(null);

  const handleExistingClick = async () => {
    setActiveLoading("existing");
    try {
      await onExistingCardSelect?.();
    } finally {
      setActiveLoading(null);
    }
  };

  const handleNewClick = async () => {
    setActiveLoading("new");
    try {
      await onNewCardSelect?.();
    } finally {
      setActiveLoading(null);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg w-[95%] rounded-2xl shadow-2xl border border-primary/20 bg-gradient-to-br from-background via-card/95 to-secondary/20 backdrop-blur-md animate-in fade-in duration-200">
        <DialogHeader className="space-y-2 text-center pb-4">
          <DialogTitle className="text-xl sm:text-2xl font-extrabold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Choose Payment Method
          </DialogTitle>
          <DialogDescription className="text-sm sm:text-base text-muted-foreground">
            Select how you’d like to pay for your upgrade.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 gap-4 p-2 sm:p-4">
          {/* Existing Card Button */}
          <button
            onClick={handleExistingClick}
            disabled={isLoading || activeLoading !== null}
            className={`group relative h-auto sm:h-24 py-5 px-6 text-base sm:text-lg 
             flex flex-col sm:flex-row items-center justify-center gap-3 
             rounded-xl border border-primary/30 bg-card text-foreground 
             transition-all duration-300 shadow-sm
             ${
               activeLoading === ("existing" || "new")
                 ? "cursor-not-allowed opacity-70"
                 : "hover:scale-[1.02] hover:shadow-xl hover:bg-accent/10 hover:border-accent hover:text-accent"
             }`}
          >
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-accent/10 group-hover:text-accent">
              {activeLoading === "existing" ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                <CreditCard className="w-5 h-5" />
              )}
            </div>
            <span className="font-medium">
              {activeLoading === "existing"
                ? "Processing..."
                : "Continue with Existing Card"}
            </span>
          </button>

          {/* New Card Button */}
          <button
            onClick={handleNewClick}
            disabled={isLoading || activeLoading !== null}
            className={`group relative h-auto sm:h-24 py-5 px-6 text-base sm:text-lg 
             flex flex-col sm:flex-row items-center justify-center gap-3 
             rounded-xl border border-primary/30 bg-card text-foreground 
             transition-all duration-300 shadow-sm
             ${
               activeLoading === ("existing" || "new")
                 ? "cursor-not-allowed opacity-70"
                 : "hover:scale-[1.02] hover:shadow-xl hover:bg-accent/10 hover:border-accent hover:text-accent"
             }`}
          >
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-accent/10 group-hover:text-accent">
              {activeLoading === "new" ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                <CreditCard className="w-5 h-5" />
              )}
            </div>
            <span className="font-medium">
              {activeLoading === "new"
                ? "Processing..."
                : "Continue with New Card"}
            </span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentMethodModal;
